import React from 'react';
import { TapeBadge } from './TapeBadge';
export function About() {
  return <section id="about" className="relative overflow-hidden bg-otter-cyan py-24" data-id="element-14">
      <div className="absolute inset-0 bg-halftone bg-halftone-size opacity-10" data-id="element-15" />

      <div className="container relative z-10 mx-auto px-4" data-id="element-16">
        <div className="flex flex-col items-center gap-12 lg:flex-row lg:gap-24" data-id="element-17">
          {/* Image Side */}
          <div className="relative w-full lg:w-1/2" data-id="element-18">
            <div className="relative mx-auto max-w-md" data-id="element-19">
              {/* Offset border block */}
              <div className="absolute -bottom-6 -right-6 top-6 left-6 border-4 border-otter-black bg-otter-bone" data-id="element-20" />

              <img src="https://cdn.magicpatterns.com/uploads/8tKqeB4J3TtzFMejFwi4fH/38.png" alt="Case, Owner of Otter Grill Cleaning" className="relative z-10 w-full border-4 border-otter-black object-cover grayscale transition-all duration-500 hover:grayscale-0" data-id="element-21" />

              <div className="absolute -left-8 top-12 z-20" data-id="element-22">
                <TapeBadge text="THE BOSS" color="blaze" rotation={-10} data-id="element-23" />
              </div>
            </div>
          </div>

          {/* Text Side */}
          <div className="w-full lg:w-1/2" data-id="element-24">
            <h2 className="font-display text-6xl tracking-tighter text-otter-black sm:text-8xl" data-id="element-25">
              MEET THE <br data-id="element-26" />{' '}
              <span className="text-otter-bone text-stroke-black" data-id="element-27">OTTER</span>
            </h2>

            <div className="mt-8 space-y-6 font-body text-xl font-semibold text-otter-black/90" data-id="element-28">
              <p data-id="element-29">
                Yo, I'm Case. I started Otter Grill Cleaning because I noticed
                everyone's backyards looked amazing, but their grills looked
                like crime scenes.
              </p>

              <blockquote className="border-l-8 border-otter-black pl-6 font-display text-3xl italic tracking-wide text-otter-bone text-stroke-black" data-id="element-30">
                "STARTED IN A BACKYARD. NOW CLEANS THE WHOLE NEIGHBORHOOD."
              </blockquote>

              <p data-id="element-31">
                We don't just spray some degreaser and call it a day. We tear it
                down, steam it, scrape it, and bring it back from the dead. It's
                dirty work, but seeing that shiny stainless steel underneath
                makes it all worth it.
              </p>
            </div>

            <div className="mt-12" data-id="element-32">
              <p className="font-body text-sm font-bold uppercase tracking-widest text-otter-black/60" data-id="element-33">
                STAY SHINING,
              </p>
              <p className="mt-2 font-accent text-5xl text-otter-black -rotate-2" data-id="element-34">
                Case
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}